import { render, staticRenderFns } from "./alibeyPopup.vue?vue&type=template&id=4ed6622b&scoped=true"
import script from "./alibeyPopup.vue?vue&type=script&lang=js"
export * from "./alibeyPopup.vue?vue&type=script&lang=js"
import style0 from "./alibeyPopup.vue?vue&type=style&index=0&id=4ed6622b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6622b",
  null
  
)

export default component.exports